import React from "react";
import { FormGroup } from "../../form/group/index";
import { Input } from "../../form/input/index";
import { InputBox } from "../../form/input.box/index";
import { Button } from "../../button/index";
import { FaBars, FaChevronDown, FaChevronUp, FaMinusCircle } from "react-icons/fa";
import { Box, BoxSection } from "../../box/index";
import { Tooltip } from "../../tooltip/index";
import { arrayMove, SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import { FormTreeSelect } from "../../form/tree/index";
import { RestaurantUtils } from "@lib/common";
const autobind = require("class-autobind").default;
const DragHandle = SortableHandle(() => {
    return (React.createElement(InputBox, { className: "no-round width40 flex-center cursor-move nb-t" },
        React.createElement("p", { className: "big font-bold" },
            React.createElement(FaBars, null))));
});
const SortableItem = SortableElement((props) => {
    const { item, itemIndex, change, remove, r, isLast, isActive, toggleActive } = props;
    return (React.createElement(Box, { key: itemIndex, className: isLast ? "no-round" : "no-round nb-b" },
        React.createElement("div", { className: "flex-line" },
            React.createElement(InputBox, { className: "no-round width40 text-center nb-t nb-l cursor", onClick: () => toggleActive(item._id) },
                React.createElement("p", { className: "big font-bold", style: { lineHeight: "36px" } }, isActive ? React.createElement(FaChevronDown, null) : React.createElement(FaChevronUp, null))),
            React.createElement(DragHandle, null),
            React.createElement(InputBox, { className: "no-round width64 text-center nb-t" },
                React.createElement("p", { className: "big font-bold", style: { lineHeight: "36px" } }, itemIndex + 1)),
            React.createElement("div", { className: "flex-grow", style: { alignItems: "flex-end" } },
                React.createElement(FormGroup, { className: "m-b-0", small_title: true, no_border: true },
                    React.createElement(Input, { type: "text", className: "no-round nb-t ", value: item.name, placeholder: "Name", required: true, onChange: (e) => change(itemIndex, "name", e.target.value) }))),
            React.createElement(Tooltip, { text: "Delete", width: 65, position: "top", disable: itemIndex !== 0 },
                React.createElement(Button, { type: "button", className: "no-round nb-t nb-r", paddinglr: 5, color: "white", onClick: () => remove(itemIndex) },
                    React.createElement(FaMinusCircle, null)))),
        isActive && (React.createElement(BoxSection, { paddingtb: 15, paddinglr: 10 },
            React.createElement(FormTreeSelect, { id: `choices-${itemIndex}`, selected: item.dishes, nodes: RestaurantUtils.menu.getTreeFilter(r, (dish) => dish.type !== "combo"), onChange: (selectedValues) => change(itemIndex, "dishes", selectedValues) })))));
});
const SortableItemContainer = SortableContainer((props) => {
    return (React.createElement("div", null, props.items.map((item, i) => (React.createElement(SortableItem, { key: `item-${i}`, index: i, r: props.r, item: item, itemIndex: i, isActive: props.inActive.indexOf(item._id) === -1, isLast: (props.items.length - 1) === i, change: props.change, remove: props.remove, toggleActive: props.toggleActive })))));
});
export class FieldDishChoices extends React.Component {
    constructor(props) {
        super(props);
        this.toggleActive = (id) => {
            const inActive = [...this.state.inActive];
            const existing = inActive.indexOf(id);
            if (existing === -1)
                inActive.push(id);
            else
                inActive.splice(existing, 1);
            this.setState({ inActive });
        };
        this.remove = (i) => {
            const values = ([...this.props.values]);
            values.splice(i, 1);
            this.props.onChange(values);
        };
        this.change = (i, key, value) => {
            const values = [...this.props.values];
            values[i][key] = value;
            this.props.onChange(values);
        };
        this.setDefault = (i, quantity) => {
            this.props.onChange(this.props.values.map((item, index) => ({
                ...item,
                quantity: i === index ? quantity : 0,
            })));
        };
        this.onSortEnd = ({ oldIndex, newIndex }) => {
            const { onChange, values } = this.props;
            onChange(arrayMove(values, oldIndex, newIndex));
        };
        autobind(this);
        this.state = {
            inActive: [],
        };
    }
    render() {
        const { values, r } = this.props;
        return (React.createElement(SortableItemContainer, { helperClass: "zindex-15 bsl-2", pressDelay: 50, useDragHandle: true, r: r, items: values, change: this.change, remove: this.remove, onSortEnd: this.onSortEnd, toggleActive: this.toggleActive, inActive: this.state.inActive }));
    }
}
//# sourceMappingURL=index.js.map